import React, { useContext } from "react";
import SEO from "../components/seo";
import Login from "../components/login/login";
import Layout from "../components/layout";
import AuthContext from "../services/firebase/auth-context/provider";
import AccountOverview from "../components/account/overview";
var LoginPage = function LoginPage() {
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: authenticated ? "Account Übersicht" : "Anmeldung"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, authenticated ? "Ihr Account" : "Anmeldung"), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8"
    }, !authenticated ? /*#__PURE__*/ React.createElement(Login, null) : /*#__PURE__*/ React.createElement(AccountOverview, null)))));
};
export default LoginPage;
